function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Forms_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "Forms_svg__a",
  transform: "translate(22 283)",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Forms_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "Forms_svg__c",
  d: "M1.433 21A1.433 1.433 0 010 19.567V4.433A1.433 1.433 0 011.433 3h21.134A1.432 1.432 0 0124 4.433v15.134A1.432 1.432 0 0122.567 21zm.067-1.5h21V8.75h-21zm21-12.25V4.5h-21v2.75zM6.75 17.75A.75.75 0 016 17a.751.751 0 01.75-.751h13a.751.751 0 01.75.751.75.75 0 01-.75.75zM3 17a.751.751 0 01.75-.751.751.751 0 01.75.751.75.75 0 01-.75.75A.75.75 0 013 17zm3.749-2.25A.751.751 0 016 14a.75.75 0 01.75-.75h13a.75.75 0 01.75.75.751.751 0 01-.75.751zM3 14a.75.75 0 01.75-.75.75.75 0 01.75.75.751.751 0 01-.75.751A.751.751 0 013 14zm3.749-2.25A.75.75 0 016 11a.75.75 0 01.75-.75h13a.75.75 0 01.75.75.75.75 0 01-.75.75zM3 11a.75.75 0 01.75-.75.75.75 0 01.75.75.75.75 0 01-.75.75A.75.75 0 013 11z"
}));

function SvgForms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgForms;